// extracted by mini-css-extract-plugin
module.exports = {"container":"_2yqcOaGV6h4wS_ZY5WgkQL","header":"_3pUp4zvl-lfA3v9JIoWLxW","title":"tHJb2YhLuVnsiprysSl7- appSubtitle"};